
import imageLewandowsky from './assets/images/program/lewandowsky.jpg'
import imageLewandowskySquare from './assets/images/program/lewandowsky-square.jpg'
import userLewandowsky from './assets/images/program/lewandowsky-user.jpg'
import slideLewandowsky from './assets/slides/lewandowsky.pdf'

import imageMueller from './assets/images/program/mueller.jpg'
import userMueller from './assets/images/program/mueller-user.jpg'
import slideMueller from './assets/slides/mueller.pdf'

import imageBuder from './assets/images/program/buder.jpg'
import userBuder from './assets/images/program/buder-user.jpg'
import slideBuder from './assets/slides/buder.pdf'

import imageFischer from './assets/images/program/fischer.jpg'
import userFischer from './assets/images/program/fischer-user.jpg'
import slideFischer from './assets/slides/fischer.pdf'

import imagePummerer from './assets/images/program/pummerer.jpg'
import userPummerer from './assets/images/program/pummerer-user.jpg'
import slidePummerer from './assets/slides/pummerer.pdf'

import imageSaid from './assets/images/program/said.jpg'
import userSaid from './assets/images/program/said-user.jpg'
import slideSaid from './assets/slides/said.pdf'

import imageHoltz from './assets/images/program/holtz.jpg'
import userHoltz from './assets/images/program/holtz-user.jpg'
import slideHoltz from './assets/slides/holtz.pdf'

import imageZollo from './assets/images/program/zollo.jpg'
import imageZolloSquare from './assets/images/program/zollo-square.jpg'
import userZollo from './assets/images/program/zollo-user.jpg'
import slideZollo from './assets/slides/zollo.pdf'

import imageRodriguez from './assets/images/program/rodriguez.jpg'
import userRodriguez from './assets/images/program/rodriguez-user.jpg'
import slideRodriguez from './assets/slides/rodriguez.pdf'

import imageStewart from './assets/images/program/stewart.jpg'
import userStewart from './assets/images/program/stewart-user.jpg'
import slideStewart from './assets/slides/stewart.pdf'

import imageWinter from './assets/images/program/winter.jpg'
import userWinter from './assets/images/program/winter-user.jpg'
import slideWinter from './assets/slides/winter.pdf'

import imageBago from './assets/images/program/bago.jpg'
import userBago from './assets/images/program/bago-user.jpg'
import slideBago from './assets/slides/bago.pdf'

import imageRoozenbeek from './assets/images/program/roozenbeek.jpg'
import userRoozenbeek from './assets/images/program/roozenbeek-user.jpg'
import slideRoozenbeek from './assets/slides/roozenbeek.pdf'

import imageHuff from './assets/images/program/huff.jpg'
import userHuff from './assets/images/program/huff-user.jpg'
import slideHuff from './assets/slides/huff.pdf'

import imageHertwig from './assets/images/program/hertwig.jpg'
import imageHertwigSquare from './assets/images/program/hertwig-square.jpg'
import userHertwig from './assets/images/program/hertwig-user.jpg'
import slideHertwig from './assets/slides/hertwig.pdf'

import placeholder from './assets/images/program/video_placeholder.jpg'

const presentations = [
    {
        id: 'mueller',
        type: 'Emergence',
        video: '54815',
        title: 'Do Social Media Polarize?',
        image: imageMueller,
        imageSquare: null,
        user: 'Phillip Müller',
        company: 'University of Mannheim',
        userImage: userMueller,
        userTooltip: 'Phillip Müller',
        abstract: 'One of the most heavily discussed questions in the context of belief polarization in recent times, is  the contribution of social media technologies. The infamous “filter bubble” hypothesis suggests that that social media algorithms are, by design, driving ideological as well as affective polarization in users. Even though empirical evidence on this mechanism is mixed, at best, this assumption has become a fixture of any debate on polarization. Drawing from a secondary analyses of large-scale panel data and a systematic literature review of empirical research on social media’s polarization effects (both work in progress), I will argue that the question whether social media contribute to polarization has to be answered much more nuancedly. Findings of the two studies indicate that we are far from having consistent evidence on polarizing effects of algorithmic content selection. Rather, social media related polarization effects seem to result from users’ own content selection choices and their active participation in social media communications (i.e., posting, sharing, liking, etc.).',
        keynote: false,
        url: 'https://www.phil.uni-mannheim.de/mkw/abteilungen/akademische-ratsstellen/dr-philipp-mueller/',
        slides: '',
        contact: '',
        aos: 'fade-right',
        aosDelay: 300
    },
    {
        id: 'buder',
        type: 'Emergence',
        //video: '189932180',
        video: '',
        title: 'A dual-pathway model of attitude polarization',
        image: imageBuder,
        imageSquare: null,
        user: 'Jürgen Buder',
        company: 'Leibniz-Institut für Wissensmedien',
        userImage: userBuder,
        userTooltip: 'Jürgen Buder',
        abstract: 'Most scholars in the field would agree that attitude polarization arises in a climate of congeniality, whether it is the tendency to surround oneself with congenial information (selective exposure) or to interact with like-minded others (homophily, echo chambers). While there is ample evidence suggesting that congeniality may lead to polarization, various empirical findings are at odds with such an explanation: 1) there is little evidence that people avoid uncongenial information; 2) it has been suggested that thinking about and expressing one’s attitude can polarize as well; and 3) there is evidence that people may also polarize when encountering dissent and controversial discussions on social media. This evidence will be reviewed, suggesting that the congeniality pathway to polarization can be complemented by an uncongeniality pathway. It will be discussed how technological factors (e.g., communicative affordances) and psychological factors (e.g., knowledge and confidence) may impact the two pathways to polarization. Implications for depolarization will also be briefly discussed.',
        keynote: false,
        url: 'https://www.iwm-tuebingen.de/www/de/personen/ma.html?uid=jbuder',
        slides: '',
        contact: '',
        aos: 'fade-right',
        aosDelay: 500
    },
    {
        id: 'lewandowsky',
        type: 'Emergence',
        video: '54795',
        title: 'From agenda-setting to furtive manipulation: The role of (social) media in political polarization',
        image: imageLewandowsky,
        imageSquare: imageLewandowskySquare,
        user: 'Stephan Lewandowsky',
        company: 'University of Bristol',
        userImage: userLewandowsky,
        userTooltip: 'Stephan Lewandowsky',
        abstract: 'Democracy is in retreat or under pressure worldwide. Even in countries with strong democracies, polarization is increasing, and the public sphere is awash in misinformation and conspiracy theories. Many commentators have blamed social media and the lack of platform governance for these unfortunate trends. I review the evidence for these claims and show how the traditional view that mainstream media are instrumental in setting the political agenda has become superseded by politicians’ power to set their own agenda through social media. I review the growing evidence that all forms of media are a causal factor in shaping a variety of political behaviors, from ethnic hate crimes to compliance with social-distancing measures. I examine the implications of this analysis through the tripartite lens of political advertising, free speech, and government regulations.',
        keynote: true,
        url: 'https://www.cogsciwa.com',
        slides: '',
        contact: '',
        aos: 'fade-up',
        aosDelay: 100
    },
    {
        id: 'fischer',
        type: 'Emergence',
        //video: '139893505',
        video: '',
        title: 'Knowing what you know in the age of misinformation: A metacognitive perspective on politicized science',
        image: imageFischer,
        imageSquare: null,
        user: 'Helen Fischer',
        company: 'Max-Planck-Institute for Human Development',
        userImage: userFischer,
        userTooltip: 'Helen Fischer',
        abstract: 'In areas of politicized science such as climate change or COVID-19, citizens are confronted with noisy information environments that mix the “signal”, scientifically accurate information, with a high proportion of “noise”, information that is misleading, de-contextualized, or outright false. In this talk, I present recent studies that explore two main questions: How does this noisy information environments affect metacognitive accuracy, the accuracy with which citizens can indicate what they do, and do not know? And how does metacognitive accuracy relate to beliefs and behavior in relation to climate change and COVID-19? Key findings from this research are that (1) citizens are metacognitively confused about what they do, and do not know about politicized science, and more so than about non-politicized science; and that (2) metacognitive accuracy explains beliefs and behavior, above and beyond object-level knowledge, and other well-known predictors. These results highlight the importance of metacognitive insight for shaping beliefs and behavior in the area of politicized science.',
        keynote: false,
        url: 'https://www.mpib-berlin.mpg.de/staff/helen-fischer',
        slides: '',
        contact: '',
        aos: 'fade-left',
        aosDelay: 300
    },
    {
        id: 'pummerer',
        type: 'Dissemination',
        video: '53411',
        title: 'On the societal effect of (Covid-19) Conspiracy Theories and its possible underlying mechanism',
        image: imagePummerer,
        imageSquare: null,
        user: 'Lotte Pummerer',
        company: 'Leibniz-Institut für Wissensmedien',
        userImage: userPummerer,
        userTooltip: 'Lotte Pummerer',
        abstract: 'Conspiracy theories offer unvalidated explanations for important societal events. Research has shown that believing in conspiracy theories is connected with negative societal consequences, such as decreased social engagement and less trust in authorities. This research has mostly used cross-sectional designs and rarely identified the underlying mechanisms. The current research set out to address both of these limitations. In one experimental and one longitudinal study, we examined the effect of a belief in a Political Covid-19 Conspiracy on attitudes and behavior in the context of the Covid-19 pandemic. Believing in a Political Covid-19 Conspiracy had detrimental effects for institutional trust and support for governmental regulations. Unexpectedly, trust did not mediate the impact of conspiracy beliefs on the detrimental societal effects. In a second set of studies we provide evidence for the role of a focus on differences as mechanism in the context of conspiracy theories.',
        keynote: false,
        url: 'https://www.iwm-tuebingen.de/www/de/personen/ma.html?uid=lpummerer',
        slides: '',
        contact: '',
        aos: 'fade-left',
        aosDelay: 500
    },
    {
        id: 'said',
        type: 'Dissemination',
        //video: '166374476',
        video: '',
        title: 'Understanding Belief Polarization – An Agent-Based Modeling Approach',
        image: imageSaid,
        imageSquare: null,
        user: 'Nadia Said',
        company: 'Eberhard Karls Universität Tübingen',
        userImage: null,
        userTooltip: 'Nadia Said',
        abstract: 'We implemented an agent-based model (ABM) to explore the influence of cognitive parameters, like working memory capacity as well as openness, on polarization of beliefs in an initially heterogeneous belief environment and showed how individual differences in openness and working memory capacity can accelerate belief polarization.<br>In this contribution we will present an extended version of our previous model and discuss (a) the influence of different initial distributions on belief polarization, (b) explore how bots influence the propagation of beliefs, (c) show simulation runs with real data from our experiment. Furthermore, we will outline the setup of our mathematical model of the ACT-R declarative memory module (Said et al. 2016) that will allow us to simulate the cognitive process of each agent in a more realistic way.',
        keynote: false,
        url: 'https://uni-tuebingen.de/fakultaeten/mathematisch-naturwissenschaftliche-fakultaet/fachbereiche/psychologie/arbeitsbereiche/angewandte-kognitionspsychologie/arbeitsbereich/n-said/',
        slides: '',
        contact: '',
        aos: 'fade-right',
        aosDelay: 300
    },
    {
        id: 'holtz',
        type: 'Dissemination',
        video: '53854',
        title: 'The Triple Filter Bubble: An Agent Based Model of the Emergence of Filter Bubbles and Echo Chambers',
        image: imageHoltz,
        imageSquare: null,
        user: 'Peter Holtz',
        company: 'Leibniz-Institut für Wissensmedien',
        userImage: userHoltz,
        userTooltip: 'Peter Holtz',
        abstract: 'The ubiquitous availability of information in the age of social media and the increasing personalization of information flows are often alleged to contribute to the emergence of "filter bubbles" and “echo chambers”. In our triple-filter-bubble model (Geschke, Lorenz, & Holtz, 2019), we formalize filtering processes on three different levels: Algorithms, group processes, and individual cognitive and motivational processes. We used the NetLogo (Wilesky, 1999) agent-based modeling environment to analyze twelve different information filtering scenarios to answer the question under which circumstances social media and automatic recommender algorithms are most likely to contribute to fragmentation of modern society. We found that echo chambers can emerge as a consequence of cognitive mechanisms (e.g., confirmation bias) alone under certain conditions. When social and technological filtering mechanisms are added to the model, polarization of society into even more distinct and less interconnected echo chambers can be observed.',
        keynote: false,
        url: 'https://www.iwm-tuebingen.de/www/en/personen/ma.html?uid=pholtz',
        slides: '',
        contact: '',
        aos: 'fade-right',
        aosDelay: 500
    },
    {
        id: 'zollo',
        type: 'Dissemination',
        video: '54796',
        title: 'Investigating Social Dynamics in the Digital Era: A Data-driven Approach',
        image: imageZollo,
        imageSquare: imageZolloSquare,
        user: 'Fabiana Zollo',
        company: 'Università Ca’ Foscari Venezia',
        userImage: userZollo,
        userTooltip: 'Fabiana Zollo',
        abstract: 'The COVID-19 pandemic has highlighted the challenge of conveying and communicating complexity and uncertainty to the public, also given the increasing central role of the Internet and social media. Designed to maximise users\' presence on the platform and to deliver targeted advertising, social media transformed the information landscape and have rapidly become the main information sources for many of their users. Information spreads faster and farther online, in a flow-through system where users have immediate access to unlimited content. This may facilitate the proliferation of mis- and dis-information, generating chaos, and limiting access to correct information. In this talk, I will provide an overview of how online social dynamics and behavioural patterns can be investigated in a quantitative and interdisciplinary way. Moreover, I will discuss how data-driven insights can be used to design tailored policy recommendations.',
        keynote: true,
        url: 'https://www.unive.it/data/people/14075308',
        slides: '',
        contact: '',
        aos: 'fade-up',
        aosDelay: 100
    },
    {
        id: 'rodriguez',
        type: 'Mitigation',
        //video: '277286149',
        video: '',
        title: 'On the Complexity of Opinions and Online Discussions',
        image: imageRodriguez,
        imageSquare: null,
        user: 'Manuel Gomez Rodriguez',
        company: 'Max Planck Institute for Software Systems',
        userImage: userRodriguez,
        userTooltip: 'Manuel Gomez Rodriguez',
        abstract: 'In an increasingly polarized world, demagogues who reduce complexity down to simple arguments based on emotion are gaining in popularity. Are opinions and online discussions falling into demagoguery? In this work, we aim to provide computational tools to investigate this question and, by doing so, explore the nature and complexity of online discussions and their space of opinions, uncovering where each participant lies. More specifically, we present a modeling framework to construct latent representations of opinions in online discussions which are consistent with human judgments, as measured by online voting. If two opinions are close in the resulting latent space of opinions, it is because humans think they are similar. Our framework is theoretically grounded and establishes a surprising connection between opinion and voting models and the sign-rank of matrices. Moreover, it also provides a set of practical algorithms to both estimate the dimensionality of the latent space of opinions and infer where opinions expressed by the participants of an online discussion lie in this space. Experiments on a large dataset from Yahoo! News, Yahoo! Finance, Yahoo! Sports, and the Newsroom app show that many discussions are multisided, reveal a positive correlation between the complexity of a discussion, its linguistic diversity and its level of controversy, and show that our framework may be able to circumvent language nuances such as sarcasm or humor by relying on human judgments instead of textual analysis.',
        keynote: false,
        url: 'https://people.mpi-sws.org/~manuelgr/',
        slides: '',
        contact: '',
        aos: 'fade-left',
        aosDelay: 300
    },
    {
        id: 'stewart',
        type: 'Mitigation',
        //video: '511257632',
        video: '',
        title: 'Persistent Disagreement and Polarization in a Bayesian Setting',
        image: imageStewart,
        imageSquare: null,
        user: 'Rush T. Stewart',
        company: 'Ludwig-Maximilians-Universität München',
        userImage: userStewart,
        userTooltip: 'Rush T. Stewart',
        abstract: 'For two ideally rational agents, does learning a finite amount of shared evidence necessitate agreement? No. But does it at least guard against belief polarization, the case in which their opinions get further apart? No. OK, but are rational agents guaranteed to avoid polarization if they have access to an infinite, increasing stream of shared evidence? No.',
        keynote: false,
        url: 'https://www.mcmp.philosophie.uni-muenchen.de/people/faculty/stewart_rush/index.html',
        slides: '',
        contact: '',
        aos: 'fade-left',
        aosDelay: 500
    },
    {
        id: 'winter',
        type: 'Mitigation',
        video: '54814',
        title: 'Open mind for a different view: Flexibility mindsets as a strategy to reduce polarization',
        image: imageWinter,
        imageSquare: null,
        user: 'Kevin Winter',
        company: 'Leibniz-Institut für Wissensmedien',
        userImage: userWinter,
        userTooltip: 'Kevin Winter',
        abstract: 'When facing (members of) social outgroups, people’s spontaneous judgements and behaviors are often guided by stereotypes and prejudice. These biases are not only a threat to harmonious intergroup relations, but also constitute a breeding ground for polarization within groups (e.g., majority societies). Flexibility mindsets are a set of mental procedures that once activated bring people to consider alternatives beyond their spontaneous responses and could, thus, contribute to overcoming such biases. Across a row of studies, we showed that flexibility mindsets can be activated by communication (e.g., using negations or rhetoric questions) in intergroup contexts and unfold their mitigating impact on biased outgroup attitudes. The potential of flexibility mindsets to be applied to other pressing social issues such as climate change or vaccination will be discussed. Overall, the generalizability of the underlying mechanism provides plenty of avenues for further research and carries the potential to design interventions that target on depolarization.',
        keynote: false,
        url: 'https://www.iwm-tuebingen.de/www/de/personen/ma.html?uid=kwinter',
        slides: '',
        contact: '',
        aos: 'fade-right',
        aosDelay: 300
    },
    {
        id: 'bago',
        type: 'Mitigation',
        video: '54816',
        title: 'Why is disbelief in anthropogenic climate change common despite broad scientific consensus to the contrary?',
        image: imageBago,
        imageSquare: null,
        user: 'Bence Bago',
        company: 'Institute for Advanced Study in Toulouse',
        userImage: userBago,
        userTooltip: 'Bence Bago',
        abstract: 'A widely-held explanation involves politically motivated reasoning: Rather than helping uncover truth, people use their reasoning abilities to protect their partisan identities and reject beliefs that threaten those identities. Despite the popularity of this account, the evidence supporting it (i) does not account for the fact that partisanship is confounded with prior beliefs about the world, and (ii) is entirely correlational with respect to the effect of reasoning. Here, we address these shortcomings by (i) measuring prior beliefs and (ii) experimentally manipulating participants’ extent of reasoning using cognitive load and time pressure while they evaluate arguments for or against anthropogenic global warming. The results challenge the politically motivated system 2 reasoning account: engaging in more reasoning led people to have greater coherence between judgments and their prior beliefs about climate change - a process that can be consistent with Bayesian reasoning.',
        keynote: false,
        url: 'https://www.iast.fr/people/bence-bago',
        slides: '',
        contact: '',
        aos: 'fade-right',
        aosDelay: 500
    },
    {
        id: 'hertwig',
        type: 'Mitigation',
        video: '54813',
        title: 'Confronting Digital Challenges with Cognitive Tools',
        image: imageHertwig,
        imageSquare: imageHertwigSquare,
        user: 'Ralph Hertwig',
        company: 'Max-Planck-Institut für Bildungsforschung',
        userImage: userHertwig,
        userTooltip: 'Ralph Hertwig',
        abstract: 'The Internet has evolved into a ubiquitous and indispensable digital environment in which people communicate, seek information, and make decisions. Despite offering various benefits, online environments are also replete with smart, highly adaptive choice architectures designed primarily to maximize commercial interests, capture and sustain users’ attention, monetize user data, and predict and influence future behavior. This online landscape holds multiple negative consequences for society, such as a decline in human autonomy, rising incivility in online conversation, the facilitation of political extremism, and the spread of disinformation. Benevolent choice architects working with regulators may curb the worst excesses of manipulative choice architectures, yet the strategic advantages, resources, and data remain with commercial players. One way to address some of this imbalance is with interventions that empower Internet users to gain some control over their digital environments, in part by boosting their information literacy and their cognitive resistance to manipulation. Another type of interventions are nudges that focus on the properties of the choice architecture and simple reminders. We focus on these two types of behavioral and cognitive interventions, nudges, and boosts, and discuss their conceptual assumptions and available behavioral evidence.',
        keynote: true,
        url: 'https://www.mpib-berlin.mpg.de/staff/ralph-hertwig',
        slides: '',
        contact: '',
        aos: 'fade-up',
        aosDelay: 100
    },
    {
        id: 'roozenbeek',
        type: 'Mitigation',
        //video: '284798034',
        video: '',
        title: 'How to “inoculate” against misinformation at scale',
        image: imageRoozenbeek,
        imageSquare: null,
        user: 'Jon Roozenbeek',
        company: 'University of Cambridge',
        userImage: userRoozenbeek,
        userTooltip: 'Jon Roozenbeek',
        abstract: 'Many efforts to fight misinformation online happen after it has already spread, for example through fact-checking and “debunking”. However, psychological studies show that repeated exposure to misinformation increases its perceived reliability, and that correcting misinformation does not always undo people’s belief in it. Researchers have therefore explored ways to prevent people from falling for misinformation in the first place. This approach is based on inoculation theory: exposing people to a weakened version of the misinformation and pre-emptively refuting it increases psychological resistance to future exposure to real misinformation. This talk explores how inoculation theory has been applied in domains where misinformation is common (such as online extremism and vaccinations) using online games and short animated videos, and how effective these interventions are in the short- to medium-term.',
        keynote: false,
        url: 'https://www.psychol.cam.ac.uk/staff/dr-jon-roozenbeek',
        slides: '',
        contact: '',
        aos: 'fade-left',
        aosDelay: 300
    },
    {
        id: 'huff',
        type: 'Mitigation',
        //video: '233562304',
        video: '',
        title: 'Rejecting journalistic media and COVID-19 denial',
        image: imageHuff,
        imageSquare: null,
        user: 'Markus Huff',
        company: 'Leibniz-Institut für Wissensmedien',
        userImage: userHuff,
        userTooltip: 'Markus Huff',
        abstract: 'Open rejection of journalistic media is a phenomenon observed among people who deny COVID-19. Those people often turn to social, non-journalistic media for information search. These provide lots of false information or even misinformation. Exposure to such information can have different consequences, manifesting in lower knowledge, less accurate meta-cognitive sensitivity, lower compliance with COVID-19 health guidelines, and lower vaccination intention. In the present study, including two German representative samples (N= 590 and N = 1067), we show that openly rejecting journalistic media is related to less information search, lower COVID-19 knowledge, and lower accuracy of confidence in COVID-19 knowledge (meta-cognitive sensitivity). However, we also show that metacognitive efficiency (i.e. the ability to discriminate between correct and incorrect verifications in their confidence while controlling for their ability to discriminate between true and false COVID-19 statements) is not different between the two groups. Thus, suggesting that people who openly reject journalistic media seem to base their answers on a different knowledge reality representing incorrect information.',
        keynote: false,
        url: 'https://www.iwm-tuebingen.de/www/de/personen/ma.html?uid=mhuff',
        slides: '',
        contact: '',
        aos: 'fade-left',
        aosDelay: 500
    }
]

window.generatePresentations = function() {

    const tooltips = {
        homepage: 'Go to Project Homepage',
        download: 'Download Slides as PDF',
        twitter: 'Share on Twitter',
        email: 'Share by Email'
    }

    let modals = ''

    $('.tile.is-child').each(function(index) {
        const presentation = presentations[index]

        const aspectRatio = presentation.keynote ? 'is-square' : 'is-4by3'
        const image = presentation.keynote ? presentation.imageSquare : presentation.image
        const titleClass = presentation.keynote ? 'keynote' : ''

        $(this).html(`
            <div class="card" data-type="${presentation.type}" data-id="${presentation.id}" data-aos="${presentation.aos}" data-aos-delay="${presentation.aosDelay}" style="height: 100%;">
                <div class="card-image">
                    <figure class="image ${aspectRatio}">
                        <img src="${image}" alt="${presentation.title}" />
                    </figure>
                </div>
                <div class="card-content">
                    <div class="media">
                        <div class="media-content">
                            <h1 class="${titleClass}">${presentation.title}</h1>
                            <h2 class="has-text-grey">
                                <div>
                                    <i class="fas fa-user"></i>
                                    <span>${presentation.user}</span>
                                </div>
                                <div>
                                    <i class="fas fa-university"></i>
                                    <span>${presentation.company}</span>
                                </div>
                            </h2>
                        </div>
                    </div>
                </div>
            </div>
        `)

        let video = ''
        let twitter = ''
        let mail = ''
        if (presentation.video) {
            video = `
                <div class="vimeo-player">
                    <iframe width="560" height="315" scrolling="no" src="//av.tib.eu/player/${presentation.video}" frameborder="0" allowfullscreen></iframe>
                </div>
            `
            twitter = `
                <a href="https://twitter.com/intent/tweet?text=View this video https://www.beliefpolarization.de/program.html?speaker=${presentation.id}" target="_blank" class="card-footer-item" data-tippy-content="${tooltips.twitter}">
                    <i class="fab fa-twitter fa-lg"></i>
                </a>
            `
            mail = `
                <a href="mailto:?subject=${presentation.title}&amp;body=View this video https://www.beliefpolarization.de/program.html?speaker=${presentation.id}" class="card-footer-item" data-tippy-content="${tooltips.email}">
                    <i class="fas fa-envelope fa-lg"></i>
                </a>
            `
        } else {
            video = `
                <figure class="image is-4by3">
                    <img src="${placeholder}" alt="Video">
                </figure>
            `
        }

        let slides = ''
        if (presentation.slides) {
            slides = `
                <a href="${presentation.slides}" target="_blank" class="card-footer-item" data-tippy-content="${tooltips.download}" download>
                    <i class="fas fa-download fa-lg"></i>
                </a>
            `
        }

        let userImage = ''
        if (presentation.userImage) {
            userImage = `
                <div class="media-left" data-tippy-content="${presentation.userTooltip}">
                    <figure class="image is-64x64">
                        <img class="is-rounded" src="${presentation.userImage}" alt="${presentation.user}" />
                    </figure>
                </div>
            `
        }

        modals += `      
            <div class="modal my-modal" data-id="${presentation.id}">
                <div class="modal-background"></div>
                <div class="modal-content">
                    <div class="my-modal-close">
                        <span data-tippy-content="Close" data-tippy-placement="right">
                            <i class="fas fa-times fa-2x"></i>
                        </span>
                    </div>
                    <div class="card">
                        <div class="card-image">
                            ${video}
                        </div>
                        <div class="card-content">
                            <div class="media">
                                ${userImage}
                                <div class="media-content">
                                    <h1>${presentation.title}</h1>
                                    <h2 class="has-text-grey">${presentation.user} &bull; ${presentation.company}</h2>
                                </div>
                            </div>
                            <div class="content my-justify">
                                ${presentation.abstract}
                            </div>
                        </div>
                        <footer class="card-footer">
                            <a href="${presentation.url}" target="_blank" class="card-footer-item" data-tippy-content="${tooltips.homepage}">
                                <i class="fas fa-home fa-lg"></i>
                            </a>
                            ${slides}
                            ${twitter}
                            ${mail}
                        </footer>
                    </div>
                </div>
            </div>
        `
    })

    $('body').append(modals)
}
